import { Tooltip } from '@hakimo-ui/shared/ui-base';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

const HELP_TEXT =
  'Pick situations to see their alarms, then choose the ones to ingest. You can also paste an alarm ID from production to ingest it directly.';

export function FormSectionHeader() {
  return (
    <h3 className="border-onlight-line-2 dark:border-ondark-line-2 text-onlight-text-1 dark:text-ondark-text-1 flex items-center gap-1.5 border-b pb-4 text-lg font-medium leading-6">
      Ingest demo alarms
      <Tooltip text={HELP_TEXT} position="bottom" size="large">
        <InformationCircleIcon
          className="text-onlight-text-3 dark:text-ondark-text-2 h-5 w-5"
          aria-label="How to ingest demo alarms"
        />
      </Tooltip>
    </h3>
  );
}
